import { ActionTypes as PageActionTypes, } from '../actions/page';
export const initialState = {
    currentPage: null,
    loadingPage: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PageActionTypes.PAGE_NAV_START:
            return pageNavStart(state, action);
        case PageActionTypes.PAGE_NAV_COMPLETE:
            return pageNavComplete(state, action);
        case PageActionTypes.PAGE_NAV_ERROR:
            return pageNavError(state, action);
    }
    return state;
};
function pageNavStart(state, action) {
    const payload = action.payload;
    return {
        ...state,
        loadingPage: payload,
    };
}
export function pageNavComplete(state, action) {
    const payload = action.payload;
    const returnState = (newPage) => ({
        ...state,
        currentPage: newPage,
        loadingPage: null,
    });
    switch (payload.pageType) {
        case 'article':
            return returnState({
                pageType: 'article',
                articleId: payload.articleId,
                status: 'has-fetched',
                path: payload.path,
            });
        case 'category':
            return returnState({
                pageType: 'category',
                categoryId: payload.categoryId,
                status: 'has-fetched',
                path: payload.path,
            });
        case 'search':
            return returnState({
                pageType: 'search',
                searchTerm: payload.searchTerm,
                status: 'has-fetched',
                path: payload.path,
            });
    }
    return returnState({
        pageType: payload.pageType,
        status: 'has-fetched',
        path: payload.path,
    });
}
export function pageNavError(state, action) {
    const payload = action.payload;
    const returnState = (newPage) => ({
        ...state,
        currentPage: newPage,
        loadingPage: null,
    });
    switch (payload.pageType) {
        case 'article':
            return returnState({
                pageType: 'article',
                articleId: payload.articleId,
                path: payload.path,
                status: payload.errorStatus,
            });
        case 'category':
            return returnState({
                pageType: 'category',
                categoryId: payload.categoryId,
                path: payload.path,
                status: payload.errorStatus,
            });
        case 'search':
            return returnState({
                pageType: 'search',
                searchTerm: payload.searchTerm,
                path: payload.path,
                status: payload.errorStatus,
            });
    }
    return returnState({
        pageType: payload.pageType,
        path: payload.path,
        status: payload.errorStatus,
    });
}
export default reducer;
//# sourceMappingURL=page.js.map